































import app from "@/app";
import { SXCompany, SXSurvey } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class WSurveysList extends BaseComponent {
	@Prop({ type: Array, required: true })
	surveys!: SXSurvey[];

	userCanEditSurvey(survey: SXSurvey) {
		return app.services.users.isCompanyAdmin(survey.company_id);
	}
}
